import { createSelector } from 'reselect';
import getIn from 'transmute/getIn';
import { OWNER_ID } from '../constants/CrmOwnerKeys';
import { getCurrentOwner } from './getCurrentOwner';
export const getCurrentOwnerId = createSelector([getCurrentOwner], currentOwner => getIn(OWNER_ID, currentOwner) || null);